import Cookies from 'js-cookie'

/**
 * Class to manage cookies agreement
 */
class CookiesController {
  constructor() {
    this.cookiesSaved = false
    this.cookies = {}
    this.getCookiesSavedInfo()

    this.fireActionEvent()

    window.addEventListener('load', () => {
      this.firePopupEvent()
    })
  }

  /**
   * Sets all cookies as not accepted and saves cookies info in localstorage
   */
  disallowAll() {
    for (const id in this.cookies) {
      if (id.includes('necessary')) {
        this.cookies[id] = true
      } else {
        this.cookies[id] = false
      }
    }

    this.saveCookiesInfo()
  }

  /**
   * Fires event that mean cookies based scripts should take action
   */
  fireActionEvent() {
    window.dispatchEvent(new CustomEvent('bw-cookies-action'))
  }

  /**
   * Fires event that mean popup component should take action
   */
  firePopupEvent() {
    window.dispatchEvent(new CustomEvent('bw-cookies-popup'))
  }

  /**
   * Checks if info about all cookies in popup is saved
   *
   * @returns {boolean} true if info about all cookies is saved, else false
   */
  allCookiesIncludes() {
    const cookiesSettings = document.querySelector(
      '[data-item="bw-cookies-settings"]'
    )
    let allCookiesIncludes = true
    if (cookiesSettings) {
      Array.from(cookiesSettings.querySelectorAll('[data-cookie]')).map(
        (cookie) => {
          if (
            !Object.keys(this.cookies).includes(
              cookie.getAttribute('data-cookie')
            )
          ) {
            allCookiesIncludes = false
          }
        }
      )
    }

    return allCookiesIncludes
  }

  /**
   * Gets saved cookies info from localstorage
   */
  getCookiesSavedInfo() {
    const acceptedCookies = localStorage.getItem('bw-accepted-cookies')

    if (acceptedCookies) {
      this.cookies = JSON.parse(acceptedCookies)
      this.cookiesSaved = true
    } else {
      this.cookies = {}
    }
  }

  /**
   * Saves cookies info in localstorage
   */
  saveCookiesInfo() {
    localStorage.setItem('bw-accepted-cookies', JSON.stringify(this.cookies))
    this.cookiesSaved = true
  }

  /**
   * @param {string} cookieId
   * @returns {boolean} true if it is accept for cookie or if accept for cookie is undefined, else false
   */
  isCookieAccepted(cookieId) {
    return this.cookies[cookieId] // || this.cookies[cookieId] === undefined;
  }

  /**
   * Adds cookie, saves cookies info and fires bw-cookies-action event
   *
   * @param {string} cookieId cookie id
   * @param {boolean} accepted is cookie accepted
   */
  addCookie(cookieId, accepted) {
    this.cookies = { ...this.cookies, [cookieId]: accepted }
    this.saveCookiesInfo()
    this.fireActionEvent()
  }

  /**
   * Adds cookie and fires bw-cookies-action event
   *
   * @param {string} cookieId cookie id
   * @param {boolean} accepted is cookie accepted
   */
  addCookieWithoutSaveing(cookieId, accepted) {
    this.cookies = { ...this.cookies, [cookieId]: accepted }
    this.fireActionEvent()
  }

  /**
   * Adds multiple cookies
   * @param {Array<{id: string, accepted: boolean}>} cookiesStatus Array of cookies status id - cookie id, accepted - is cookie accepted
   */
  addCookies(cookiesStatus) {
    cookiesStatus.forEach((cookieStatus) => {
      this.addCookie(cookieStatus.id, cookieStatus.accepted)
    })
  }
}

/**
 * Base class for cookies popup
 */
export class CookiesPopup {
  /**
   * Set base popup container and start method which add event listeners.
   * @param {Element} cookiesBox  base popup container.
   */
  constructor(cookiesBox) {
    this.cookiesSettingsBox = cookiesBox

    if (this.isNewCookie()) {
      this.addEventHandlers()
    } else {
      const btnReopen = document.querySelector(
        '[data-cookies-btn-reopen="reopen"]'
      )

      if (btnReopen) {
        btnReopen.classList.remove('hidden')
      }
    }
  }

  addEventHandlers() {}

  /**
   * Checks that all cookies are saved and there no new cookies.
   * If any new cookie show popup.
   *
   * @returns {boolean} true if new cookies.
   */
  isNewCookie() {}

  /**
   * Clears localstorage and cookies which don't have 'bw' in name.
   */
  clearStorage() {
    const cookies = document.cookie.split(';').map((cookie) => {
      const splited = cookie.split('=')

      if (splited.length > 0) return splited[0]
    })

    cookies.forEach((cookieName) => {
      if (cookieName.search('bw') === -1) {
        Cookies.remove(cookieName.trim())
      }
    })

    Object.keys(localStorage).forEach((key) => {
      if (key.search('bw') === -1) {
        localStorage.removeItem(key)
      }
    })
  }
}

export default new CookiesController()
